import { createStore } from 'zustand/vanilla'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { commonConnectors } from '@/lib/filters/filters'
import { useStore } from 'zustand'

export interface SearchState {
  search?: string
  setSearch: (search: string | undefined) => void
  searchMainCategorySlug?: string
  setSearchMainCategorySlug: (searchMainCategorySlug: string | undefined) => void
  searchKeywords: string[]
}

export const searchStore = createStore<SearchState>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        search: undefined,
        searchKeywords: [],
        setSearch: (search) => {
          set({ search: search ? search.trim() : undefined })
          if (search) {
            const keywords =
              search
                ?.split(' ')
                .filter((term) => term.length > 0)
                .map((keyword) => keyword.trim().toLowerCase())
                .filter((keyword) => !commonConnectors.includes(keyword)) ?? []
            set({ searchKeywords: keywords })
          } else {
            set({ searchKeywords: [] })
          }
        },
        searchMainCategorySlug: undefined,
        setSearchMainCategorySlug: (searchMainCategorySlug) => {
          set({ searchMainCategorySlug })
        },
      }),
      { name: 'SearchStore' }
    )
  )
)

export const useSearchStore = <T>(selector: (s: SearchState) => T) => useStore(searchStore, selector)
